module.exports = __webpack_public_path__ + "img/appltCourse-img10.6b3715db.png";